// @flow
import React from 'react'
import I18n from 'i18n-react'
import classNames from 'classnames'

import StringEnum from './StringEnum'
import Radio from './Radio'

// types
import type { DefaultFormFieldState, DefaultFormFieldType } from './AbstractFormField'

type RadioSelectProps = DefaultFormFieldType & {
  domain: {
    _type: string,
    values: Array<string>,
  },
  value?: {
    [key: string]: string,
  },
  showRemove?: boolean,
}

type SelectedValue = {
  [key: string]: string,
}

type RadioSelectState = DefaultFormFieldState & {
  options: Array<SelectedValue>,
  pristine: boolean,
  value: SelectedValue,
  ulClass: string,
  liClass: string,
}

export default class RadioSelect extends StringEnum<RadioSelectProps, RadioSelectState> {
  defaultProps = {
    ulClass: '',
    liClass: '',
  }

  render() {
    const { prefix, id, valueNames, showRemove, ulClass, liClass } = this.props
    const { options, value } = this.state
    if (this.props.textMode) {
      if (showRemove && !this.props.value) {
        return <span>{this.props.valueNames.remove}</span>
      }
      return <span>{this.state.labels ? this.state.labels[this.props.value] : this.props.value}</span>
    }

    const classes = []
    if (this.hasErrors() && !this.isPristine()) {
      classes.push('is-invalid')
    }

    return (
      <div className="d-block">
        <div className={classNames(classes)}>
          <ul className={`list child-mb-0 small-spacing ${ulClass}`}>
            {showRemove && (
              <li className={`py-2 ${liClass}`} key={`${prefix}${id}-remove`}>
                <Radio
                  checked={!value}
                  enabled
                  id={`${prefix}${id}remove`}
                  label={valueNames.remove}
                  name={`${prefix}${id}`}
                  onChange={() => {
                    this.handleOnChange('')
                  }}
                  value="remove"
                />
              </li>
            )}
            {options.map((option) => (
              <li className={`py-2 ${liClass}`} key={`${prefix}${id}-${option.value}`}>
                <Radio
                  checked={`${value ? value.value : ''}` === `${option.value}`}
                  enabled
                  id={`${prefix}${id}${option.label}`}
                  label={`${option.label}`}
                  name={`${prefix}${id}`}
                  onChange={() => {
                    this.handleOnChange(option)
                  }}
                  value={option.value}
                />
              </li>
            ))}
          </ul>
          {this.renderError()}
        </div>
      </div>
    )
  }
}
